
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 68.94 70.47"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.85 20.78h3.93v18.24l-2.82.48v3.8h10.8v-3.8l-2.82-.48V20.78h3.92l.25 2.89h4.59v-7.33H24v7.33h4.61l.24-2.89z"}}),_c('path',{attrs:{"d":"M55.62 4.86H16.36A10.3 10.3 0 006.15 15.22v40a10.3 10.3 0 0010.21 10.39h39.26a10.3 10.3 0 0010.21-10.37v-40A10.3 10.3 0 0055.62 4.86zM15.41 50V12A1.6 1.6 0 0117 10.4h38a1.6 1.6 0 011.6 1.6v38a1.6 1.6 0 01-1.6 1.6H17a1.6 1.6 0 01-1.59-1.6zm1.6 5.6H55a5.6 5.6 0 005.6-5.6V12a4.53 4.53 0 000-.52 6.36 6.36 0 011.22 3.74v40a6.23 6.23 0 01-6.14 6.3H16.36a6.23 6.23 0 01-6.14-6.3v-40a6.36 6.36 0 011.22-3.74 4.53 4.53 0 000 .52v38A5.6 5.6 0 0017 55.56z"}})])
          )
        }
      }
    